import React,{Component} from 'react';
import Aux from '../../hoc/Aux';
import classes from './Layout.css';
import Toolbar from '../Navigation/Toolbar/Toolbar';
import SideDrawer from '../Navigation/Sidedrawer/SideDrawer.jsx';
import { connect } from 'react-redux';

class Layout extends Component{

	state={
		showDrawer: false
	}

	sideDrawerHandler=()=>{
		this.setState({showDrawer: false});
	}

	toggleHandler=()=>{
		this.setState(prevState=> ({showDrawer: !prevState.showDrawer}));
	}


	render(){
		return(
			<Aux>
				<Toolbar toggler={this.toggleHandler} isAuth ={this.props.isAuthenticated}/>
					<SideDrawer show={this.state.showDrawer} click={this.sideDrawerHandler} isAuth ={this.props.isAuthenticated}/>
					<main className={classes.container}>
						{this.props.children}
					</main>
			</Aux>
		)
	}

}

const mapStateToProps = state =>{
	return {
		isAuthenticated: state.auth.token != null
	}
}

export default connect(mapStateToProps)(Layout);



// WEBPACK FOOTER //
// ./src/components/Layout/Layout.jsx